// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  type DefaultErrorResponse,
  DefaultErrorResponseFromJSON,
  DefaultErrorResponseToJSON,
} from "../models/DefaultErrorResponse";
import {
  type PageIdentityProvider,
  PageIdentityProviderFromJSON,
  PageIdentityProviderToJSON,
} from "../models/PageIdentityProvider";
import {
  type PageTenantRead,
  PageTenantReadFromJSON,
  PageTenantReadToJSON,
} from "../models/PageTenantRead";
import {
  type TenantCreate,
  TenantCreateFromJSON,
  TenantCreateToJSON,
} from "../models/TenantCreate";
import { type TenantRead, TenantReadFromJSON, TenantReadToJSON } from "../models/TenantRead";
import {
  type TenantUpdate,
  TenantUpdateFromJSON,
  TenantUpdateToJSON,
} from "../models/TenantUpdate";
import {
  type ValidationErrorResponse,
  ValidationErrorResponseFromJSON,
  ValidationErrorResponseToJSON,
} from "../models/ValidationErrorResponse";

export interface SyncToHccRequest {
  /**
   *
   */
  tenantId: string;
}

export interface TenantCreateRequest {
  /**
   *
   */
  tenantCreate: TenantCreate;
}

export interface TenantDestroyRequest {
  /**
   *
   */
  tenantId: string;
}

export interface TenantIdentityProvidersRequest {
  /**
   *
   */
  tenantId: string;
}

export interface TenantListRequest {
  /**
   *
   */
  limit?: number;
  /**
   *
   */
  offset?: number;
  /**
   *
   */
  orderBy?: TenantListOrderByEnum;
  /**
   *
   */
  orderByCaseSensitive?: boolean;
  /**
   *
   */
  userId?: string | null;
}

export interface TenantPermissionsRequest {
  /**
   *
   */
  tenantId: string;
}

export interface TenantRetrieveRequest {
  /**
   *
   */
  tenantId: string;
}

export interface TenantUpdateRequest {
  /**
   *
   */
  tenantId: string;
  /**
   *
   */
  tenantUpdate: TenantUpdate;
}

/**
 *
 */
export class TenantsApi extends runtime.BaseAPI {
  /**
   * Creates request options for syncToHcc without sending the request
   */
  async syncToHccRequestOpts(requestParameters: SyncToHccRequest): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling syncToHcc().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/sync-to-hcc`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Sync the tenant (id) to all related organisations in HCC
   * Sync tenant (id) to organisations in HCC
   */
  async syncToHccRaw(
    requestParameters: SyncToHccRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: string | null }>> {
    const requestOptions = await this.syncToHccRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Sync the tenant (id) to all related organisations in HCC
   * Sync tenant (id) to organisations in HCC
   */
  async syncToHcc(
    requestParameters: SyncToHccRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: string | null }> {
    const response = await this.syncToHccRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tenantCreate without sending the request
   */
  async tenantCreateRequestOpts(
    requestParameters: TenantCreateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantCreate"] == null) {
      throw new runtime.RequiredError(
        "tenantCreate",
        'Required parameter "tenantCreate" was null or undefined when calling tenantCreate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_create",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants`;

    return {
      path: urlPath,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: TenantCreateToJSON(requestParameters["tenantCreate"]),
    };
  }

  /**
   * Provide relevant details for the to be created tenant in the Rana instance.
   * create new tenant
   */
  async tenantCreateRaw(
    requestParameters: TenantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TenantRead>> {
    const requestOptions = await this.tenantCreateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TenantReadFromJSON(jsonValue));
  }

  /**
   * Provide relevant details for the to be created tenant in the Rana instance.
   * create new tenant
   */
  async tenantCreate(
    requestParameters: TenantCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TenantRead> {
    const response = await this.tenantCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tenantDestroy without sending the request
   */
  async tenantDestroyRequestOpts(
    requestParameters: TenantDestroyRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling tenantDestroy().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_delete",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Remove a tenant from Rana.
   */
  async tenantDestroyRaw(
    requestParameters: TenantDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    const requestOptions = await this.tenantDestroyRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Remove a tenant from Rana.
   */
  async tenantDestroy(
    requestParameters: TenantDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.tenantDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * Creates request options for tenantIdentityProviders without sending the request
   */
  async tenantIdentityProvidersRequestOpts(
    requestParameters: TenantIdentityProvidersRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling tenantIdentityProviders().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    let urlPath = `/tenants/{tenant_id}/identity-providers`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return identity providers available for an individual tenant.
   * show tenant identity providers
   */
  async tenantIdentityProvidersRaw(
    requestParameters: TenantIdentityProvidersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageIdentityProvider>> {
    const requestOptions = await this.tenantIdentityProvidersRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      PageIdentityProviderFromJSON(jsonValue)
    );
  }

  /**
   * Return identity providers available for an individual tenant.
   * show tenant identity providers
   */
  async tenantIdentityProviders(
    requestParameters: TenantIdentityProvidersRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageIdentityProvider> {
    const response = await this.tenantIdentityProvidersRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tenantList without sending the request
   */
  async tenantListRequestOpts(requestParameters: TenantListRequest): Promise<runtime.RequestOpts> {
    const queryParameters: any = {};

    if (requestParameters["limit"] != null) {
      queryParameters["limit"] = requestParameters["limit"];
    }

    if (requestParameters["offset"] != null) {
      queryParameters["offset"] = requestParameters["offset"];
    }

    if (requestParameters["orderBy"] != null) {
      queryParameters["order_by"] = requestParameters["orderBy"];
    }

    if (requestParameters["orderByCaseSensitive"] != null) {
      queryParameters["order_by_case_sensitive"] = requestParameters["orderByCaseSensitive"];
    }

    if (requestParameters["userId"] != null) {
      queryParameters["user_id"] = requestParameters["userId"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_list",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants`;

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return a list with tenant identification codes in the Rana instance.
   * list available tenants
   */
  async tenantListRaw(
    requestParameters: TenantListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<PageTenantRead>> {
    const requestOptions = await this.tenantListRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => PageTenantReadFromJSON(jsonValue));
  }

  /**
   * Return a list with tenant identification codes in the Rana instance.
   * list available tenants
   */
  async tenantList(
    requestParameters: TenantListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<PageTenantRead> {
    const response = await this.tenantListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tenantPermissions without sending the request
   */
  async tenantPermissionsRequestOpts(
    requestParameters: TenantPermissionsRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling tenantPermissions().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}/permissions`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return list is of available permissions for user in tenant.
   * list of available permissions
   */
  async tenantPermissionsRaw(
    requestParameters: TenantPermissionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<{ [key: string]: boolean | null }>> {
    const requestOptions = await this.tenantPermissionsRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse<any>(response);
  }

  /**
   * Return list is of available permissions for user in tenant.
   * list of available permissions
   */
  async tenantPermissions(
    requestParameters: TenantPermissionsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<{ [key: string]: boolean | null }> {
    const response = await this.tenantPermissionsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tenantRetrieve without sending the request
   */
  async tenantRetrieveRequestOpts(
    requestParameters: TenantRetrieveRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling tenantRetrieve().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_retrieve",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    };
  }

  /**
   * Return detailed information of an individual tenant in the Rana instance.
   * show tenant details
   */
  async tenantRetrieveRaw(
    requestParameters: TenantRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TenantRead>> {
    const requestOptions = await this.tenantRetrieveRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TenantReadFromJSON(jsonValue));
  }

  /**
   * Return detailed information of an individual tenant in the Rana instance.
   * show tenant details
   */
  async tenantRetrieve(
    requestParameters: TenantRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TenantRead> {
    const response = await this.tenantRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Creates request options for tenantUpdate without sending the request
   */
  async tenantUpdateRequestOpts(
    requestParameters: TenantUpdateRequest
  ): Promise<runtime.RequestOpts> {
    if (requestParameters["tenantId"] == null) {
      throw new runtime.RequiredError(
        "tenantId",
        'Required parameter "tenantId" was null or undefined when calling tenantUpdate().'
      );
    }

    if (requestParameters["tenantUpdate"] == null) {
      throw new runtime.RequiredError(
        "tenantUpdate",
        'Required parameter "tenantUpdate" was null or undefined when calling tenantUpdate().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", [
        "tenant_manage",
      ]);
    }

    if (
      this.configuration &&
      (this.configuration.username !== undefined || this.configuration.password !== undefined)
    ) {
      headerParameters["Authorization"] =
        "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
    }

    let urlPath = `/tenants/{tenant_id}`;
    urlPath = urlPath.replace(
      "{tenant_id}",
      encodeURIComponent(String(requestParameters["tenantId"]))
    );

    return {
      path: urlPath,
      method: "PATCH",
      headers: headerParameters,
      query: queryParameters,
      body: TenantUpdateToJSON(requestParameters["tenantUpdate"]),
    };
  }

  /**
   * Provide relevant details to be updated for the tenant in the Rana instance.
   * update existing tenant
   */
  async tenantUpdateRaw(
    requestParameters: TenantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<TenantRead>> {
    const requestOptions = await this.tenantUpdateRequestOpts(requestParameters);
    const response = await this.request(requestOptions, initOverrides);

    return new runtime.JSONApiResponse(response, (jsonValue) => TenantReadFromJSON(jsonValue));
  }

  /**
   * Provide relevant details to be updated for the tenant in the Rana instance.
   * update existing tenant
   */
  async tenantUpdate(
    requestParameters: TenantUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<TenantRead> {
    const response = await this.tenantUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}

/**
 * @export
 */
export const TenantListOrderByEnum = {
  Id: "id",
  Id2: "-id",
  Name: "name",
  Name2: "-name",
  CreatedAt: "created_at",
  CreatedAt2: "-created_at",
  UpdatedAt: "updated_at",
  UpdatedAt2: "-updated_at",
} as const;
export type TenantListOrderByEnum =
  (typeof TenantListOrderByEnum)[keyof typeof TenantListOrderByEnum];
